import { render } from "./ReviewsPage.vue?vue&type=template&id=88bc0114&ts=true"
import script from "./ReviewsPage.vue?vue&type=script&lang=ts"
export * from "./ReviewsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__